import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Header from './components/Header'
import Footer from './components/Footer'
import ScrollToTop from './components/ScrollToTop'
import FloatingContact from './components/FloatingContact'
import GoogleMap from './components/GoogleMap'
import Forside from './pages/Forside'
import JegTilbyder from './pages/JegTilbyder'
import Kontakt from './pages/Kontakt'
import Galleri from './pages/Galleri'
import Job from './pages/Job'
import GDPR from './pages/GDPR'
import YdelseDetail from './pages/YdelseDetail'
import ProjektDetail from './pages/ProjektDetail'

function App() {
  return (
    <div className="relative min-h-screen flex flex-col bg-silver-200 text-slate-900 antialiased selection:bg-amber-500 selection:text-slate-950">
      {/* Scroll restoration */}
      <ScrollToTop />

      {/* Navigation Header */}
      <Header />

      {/* Floating Contact Buttons (shows on all subpages) */}
      <FloatingContact />

      {/* Main Content Area */}
      <main className="flex-grow">
        <Routes>
          {/* Main Pages */}
          <Route path="/" element={<Forside />} />
          <Route path="/jeg-tilbyder" element={<JegTilbyder />} />
          <Route path="/kontakt" element={<Kontakt />} />
          
          {/* Secondary Pages */}
          <Route path="/galleri" element={<Galleri />} />
          <Route path="/job" element={<Job />} />
          <Route path="/gdpr" element={<GDPR />} />

          {/* Dynamic Service Detail Pages */}
          <Route path="/certifikatsvejsning" element={<YdelseDetail />} />
          <Route path="/fjernvarme-svejsning-montering" element={<YdelseDetail />} />
          <Route path="/muffemontering" element={<YdelseDetail />} />

          {/* Dynamic Project Detail Pages */}
          <Route path="/projekt" element={<ProjektDetail />} />
          <Route path="/projekt-2" element={<ProjektDetail />} />
          <Route path="/projekt-3" element={<ProjektDetail />} />
          <Route path="/projekt-4" element={<ProjektDetail />} />
          <Route path="/brud-i-farum" element={<ProjektDetail />} />

          {/* Fallback route - redirect to home */}
          <Route path="*" element={<Forside />} />
        </Routes>
      </main>

      {/* Bottom map on all pages */}
      <GoogleMap />

      {/* Footer */}
      <Footer />
    </div>
  )
}

export default App
